<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'

}
</script>

<style>
#app {
  width: 100%;
  margin: 0px;
}
.el-carousel__indicator--horizontal .el-carousel__button {
  width: 12px;
  height: 12px;
  background: rgb(221, 221, 221);
  border-radius: 50%;
  margin-right: 20px;
}
.el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 12px;
  height: 12px;
  background: rgb(29, 42, 182);
  border-radius: 50%;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue